import styled from 'styled-components';
import tw from 'twin.macro';

import { Link } from '@/atoms/Link';

export const Footer = ({ fromSignUp = false }: FooterProps): JSX.Element => {
  const isAzure = import.meta.env.VITE_CLOUD_PROVIDER === 'azure';
  const aws = `Continue with Google/ Continue with Apple
      ${fromSignUp ? 'Register' : 'Login'}`;
  const azure = 'Continue with Microsoft';

  return (
    <Wrapper>
      By clicking &quot;{isAzure ? azure : aws}&quot;&nbsp; above, you
      acknowledge that you have read and agree to the &nbsp;
      <Link href='http://needl.ai/tos.html' underline shouldStyle size='xs'>
        Terms of Use
      </Link>
      &nbsp;and&nbsp;
      <Link href='http://needl.ai/privacy.html' underline shouldStyle size='xs'>
        Privacy Policy
      </Link>
      .
    </Wrapper>
  );
};

const Wrapper = styled.div`
  ${tw`body-xs text-gray-700 px-4 text-center sm:text-left`}
  > a {
    ${tw`body-xs`}
  }
`;

type FooterProps = {
  fromSignUp: boolean;
};
